import angular from 'angular';

angular.module('cxTable').directive('cxFilterPopupItem', [
  '$compile',
  function($compile) {
    return {
      restrict: 'A',

      link: function(scope, el, attrs) {
        var options = scope.$eval(attrs.cxFilterPopupItem);
        var newEl = null;
        if (options.itemTemplate) {
          newEl = $('<ng-include src="\'' + options.itemTemplate + '\'"></ng-include>');
        } else if (options.itemExpression) {
          newEl = $('<span>{{' + options.itemExpression + '}}</span>');
        } else {
          newEl = $('<span>{{item.value}}</span>');
        }
        $compile(newEl)(scope);
        el.append(newEl);
      },
    };
  },
]);
